import React from 'react';
import { t } from '@sm/intl';
import { Typography } from '@wds/typography';
import { Button } from '@wds/button';
import { Box } from '@wds/box';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';

import audienceFeatures from './config/features';
import EnabledCheckMark from './components/EnabledCheckMark';
import DisabledCheckMark from './components/DisabledCheckMark';
import usePricingFooterStyles from './useStyles';

import COPY from '~pricing/components/PricingFooter/copy';

export default function PricingFeatures(): JSX.Element {
  const { Features, Header, Content, Feature, FeatureList } = usePricingFooterStyles();
  const { pageUtSource } = useTrackingDetails();
  const utSource2 = pageUtSource?.includes('indv') ? 'pricing_individual' : 'pricing';

  return (
    <Box element="article" data-testid="PricingFeatures">
      <Box className={Header}>
        <Typography color="dark" component="h1" variant="body" align="center">
          {t(COPY.PAID_FEATURES)}
        </Typography>
      </Box>
      <Box className={Features}>
        <Box px={5} pt={4} className={Content}>
          <Typography component="p">
            {t(COPY.SURVEY_RESPONSES)} <strong>{t(COPY.AUDIENCE)}</strong>
          </Typography>

          <Typography component="p">{t(COPY.TARGET_PEOPLE)}</Typography>

          <Box mb={4}>
            <Button
              href={`/collect/audience/preview/?ut_source=pricing&ut_source2=${utSource2}`}
              color="upgrade"
              data-testid="PricingFeatures__UpsellButton"
            >
              {t(COPY.BUY_RESPONSES)}
            </Button>
          </Box>

          <Typography component="h2" variant="body">
            {t(COPY.ADVANCE_SURVEY)}
          </Typography>

          <Box element="ul" className={FeatureList}>
            {audienceFeatures?.map(feature => {
              const copyKey = `AUDIENCE_${feature.name.toUpperCase()}` as keyof typeof COPY;
              return (
                <Box element="li" key={feature.name} className={Feature}>
                  {feature.included ? <EnabledCheckMark /> : <DisabledCheckMark />}
                  <Typography color="dark" variant="bodySm">
                    {t(COPY[copyKey])}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
